import * as Preact from "preact"

import App from "@fae/source/models/App.js"
import World from "@fae/source/models/World.js"
import * as PlotSteps from "@fae/source/data/plot/steps.js"
import * as PlotConditions from "@fae/source/data/plot/conditions.js"
import * as PlotScripts from "@fae/source/data/plot/scripts.js"

import Navigation from "@fae/source/engine/navigating/Navigation.js"
import Geometry from "@fae/source/utility/Geometry.js"
import Step from "@fae/source/models/Step.js"
import Objdict from "objdict"

import ProgressReportsHUD from "@fae/source/data/games/school/views/ProgressReportsHUD.jsx"

import HandleSlowDeath from "@fae/source/data/games/ember/scripts/HandleSlowDeath.js"
import HandleStatusEffects from "@fae/source/data/games/ember/scripts/HandleStatusEffects.js"
import HandleArmor from "@fae/source/data/games/ember/scripts/HandleArmor.js"
import GenerateStudents from "@fae/source/data/games/school/scripts/GenerateStudents.js"

import LevelUp from "@fae/source/data/games/school/scripts/LevelUp.jsx"
import ChapterSummary from "@fae/source/data/games/school/scripts/ChapterSummary.jsx"
import SavePlayerState from "@fae/source/data/games/school/scripts/SavePlayerState.js"

export default {
    "key": "preps",
    "stage": {
        "images": [
            {
                "url": require("../../dotgridbg.png"),
                "position": {"x": 0, "y": 0, "z": -1},
                "screenspace": "camera",
                "width": 16, "height": 9,
            },
            // {
            //     "url": require("./room.png"),
            //     "position": {"x": 0, "y": 0, "z": 2},
            //     "width": 16, "height": 9,
            //     "isSquiggling": true,
            // },
            {
                "type": "lined-polygon",
                "position": {"x": 0, "y": 0, "z": 2},
                "points": require("./encounters.json")[0].points,
                "color": "#000",
                "isSquiggling": true,
            }
        ],
        "units": require("./units.json"),
        "world": World.parse({
            "width": 16,
            "height": 9,
            "blocks": require("./blocks.json"),
            "spots": require("./spots.json"),
            "encounters": require("./encounters.json"),
        }),
        "hud": function(stage) {
            if(stage?.flags["hud"] == "hidden") {
                return (
                    <div class="TutorialPrompt" isHidden={true}/>
                )
            }

            return (
                <ProgressReportsHUD stage={stage}/>
            )
            // if(stage.flags["tutorial:hasRallied"] != true) {
            //     return (
            //         <div class="TutorialPrompt" position="topright">
            //             <div class="Text">
            //                 The firekeeper has the power to RALLY her friends,
            //                 allowing them to act twice in a turn.
            //             </div>
            //         </div>
            //     )
            // }
            return (
                <div class="TutorialPrompt" isHidden={true}/>
            )
        },
        "scripts": [
            {
                "trigger": "turn:0:start",
                "events": [
                    Step.flag("hud", "hidden"),
                    Step.flag("ShowAllTheGuys", true),
                    Step.flag("ShowAllTheGuysWithoutTransparency", true),
                    PlotSteps.ReportStartingAnalytics(),
                    PlotSteps.SpawnPlayerParty({"spotTag": "goodspawn"}),
                    PlotSteps.PlayAudio("Ember:Music:Combat"),
                    function() {
                        const currentTime = App?.game?.overworld?.currentTime ?? 1
                        return GenerateStudents({
                            "unitCount": currentTime <= 5 ? 3 : 4,
                            "level": Math.min(5, Math.max(1, Math.floor(currentTime / 2) + 1)),
                            "jobKeys": ["school/bow", "school/axe", "school/shaman", "school/shaman", "school/priest", "school/priest"],
                            "title": "Prep",
                            "images": {
                                "school/bow": require("@fae/source/assets/images/teach-tactics/mapsprite-PREPBLUE.png"),
                                "school/priest": require("@fae/source/assets/images/teach-tactics/mapsprite-PREPBLUE.png"),
                                // "school/dagger": require("@fae/source/assets/images/teach-tactics/mapsprite-PREPRED.png"),
                                "school/axe": require("@fae/source/assets/images/teach-tactics/mapsprite-PREPGREEN.png"),
                                "school/shaman": require("@fae/source/assets/images/teach-tactics/mapsprite-PREPGREEN.png"),
                            }
                        })
                    },
                    (stage) => {
                        if(window.hasSeenGothDialogue != true) {
                            window.hasSeenGothDialogue = true // TODO: turn this into flags
                            return [
                                "Prep: Oooo, look what crawled out of the sewer",
                                "Meanie: They say she learned her magic from roaches",
                                "Goth: Roaches' resiliency under compression is inspir--",
                                "Prep: Doesn't your playtime magic make everyone sick?",
                                "Goth: It doesn't hurt you. Well, not in the end. Easier to show you",
                                "((Demonstrates the harm-heal spell))",
                                "Prep: Eeek, it's bubbling back into place! I don't need that anymore",
                                "Prep: Let's clean up our study from this impure magic",
                                "((Blasts the Goth with water magic))",
                                "Punk: What, a fight? Me too! Come at me instead, ya punks! ORAAAA",
                            ]
                        }
                    },
                    Step.flag("modal", null),
                    Step.flag("hud", null),
                ]
            },
            {
                "type": "condition",
                "isWinCondition": true,
                "condition": (stage) => {
                    return PlotConditions.areAllUnaffiliatedUnitsDefeated(stage, {
                            "affiliation": stage.player.affiliation
                        }) || PlotConditions.areAllAffiliatedUnitsDefeated(stage, {
                            "affiliation": stage.player.affiliation,
                            "doNotIncludeUnitKey": "teacher"
                        })
                },
                "events": [
                    PlotSteps.ChapterSuccess({"message": "Class Dismissed"}),
                    ChapterSummary(),
                    LevelUp(),
                    function(stage) {
                        if(App.game.player.units.goth.isRecruited != true) {
                            return [
                                "GOTH: YOU'RE A CURISOITY, I'LL GIVE YOU THAT.",
                                "GOTH HAS JOINED YOUR PARTY!!",
                                {"func": () => {
                                    App.game.player.units.goth.isRecruited = true
                                    App.game.player.units.goth.affiliation = "good"
                                }},
                                Step.deltastage({"unit": {"key": "goth", "affiliation": "good"}}),
                            ]
                        }
                    },
                    PlotSteps.TransitionStart({"isUnskippable": true}),
                    {"func": () => Navigation.go("/games/school/overworld")},
                    PlotSteps.TransitionEnd({"isUnskippable": true}),
                    PlotSteps.Wait(500),
                    {"func": () => App.game.player.overworld.currentTime += 1},
                    SavePlayerState(),
                    // if not unlocked yet, unlock ch4
                ]
            },
            {
                "trigger": "turn:every-odd:end",
                "events": [
                    HandleSlowDeath(),
                    HandleStatusEffects(),
                    HandleArmor(),
                ]
            },
        ]
    },
}
